(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
// SPドロワー
const drawer = document.querySelector('.js-drawer');
const drawerOverlay = document.querySelector('.js-drawer-overlay');
const drawerOpen = document.querySelector('.js-drawer-open');
const drawerClose = document.querySelector('.js-drawer-close');

if (drawerOpen) {
drawerOpen.addEventListener('click', () => {
drawer.classList.add('is-open');
drawerOverlay.classList.add('is-open');
document.body.style.overflow = 'hidden';
});
}
const closeDrawer = () => {
drawer.classList.remove('is-open');
drawerOverlay.classList.remove('is-open');
document.body.style.overflow = '';
};
if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-search"]) return;
  try {
    
document.getElementById('search_form').addEventListener('submit', function(e) {
e.preventDefault();

const q = document.getElementById('search_input').value.trim();
const maker = document.getElementById('search_maker');
const category = document.getElementById('search_category').value;

const makerValue = maker.options[maker.selectedIndex].value;
const makerText = maker.options[maker.selectedIndex].text;

if (category) {
const params = new URLSearchParams();
params.set('filter.p.m.custom._item__category', category);
if (makerValue) params.set('filter.p.m.custom._item__maker', makerText);
if (q) params.set('q', q);
window.location.href = '/collections/' + category + '?' + params.toString();
} else if (makerValue) {
// メーカーのみ or メーカー＋フリーワード
const params = new URLSearchParams();
params.set('filter.p.m.custom._item__maker', makerText);
if (q) params.set('q', q);
window.location.href = '/collections/all?' + params.toString();
} else {
// フリーワードのみ
const params = new URLSearchParams();
params.set('type', 'product');
if (q) params.set('q', q);
window.location.href = '/search?' + params.toString();
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m__header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
